var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.674 4.324a2.08 2.08 0 0 0-2.94 0l-5.998 6a3.487 3.487 0 0 0 0 4.937 3.497 3.497 0 0 0 4.941 0l4.747-4.75a.75.75 0 0 1 1.06 1.06l-4.748 4.753a4.994 4.994 0 0 1-7.063-7.062l6-6a3.578 3.578 0 1 1 5.063 5.06l-5.743 5.743a2.343 2.343 0 0 1-3.312-3.312l4.743-4.742a.75.75 0 0 1 1.06 1.06l-4.741 4.744a.839.839 0 1 0 1.188 1.188l5.743-5.742a2.08 2.08 0 0 0 0-2.94z"
  })));
};
export default SvgAttachment;